// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__QHxpH","block-scrolling":"Backdrop_block-scrolling__tQ4z1","close":"Backdrop_close__jB8F8"};